/**
 * @file getter
 */


export function env(state) {
    return state;
}
export function loading(state) {
    return state.loading;
}
export function userInfo(state) {
    return state.userInfo;
}

